// AUTO-GENERATED SQL Builder (V40 Final) for BookingDispute
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingDisputeSql {
  private ast = new SqlAst('BookingDispute', 'bookingDispute');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public raisedByCustomerId: SqlField;
  public reasonCode: SqlField;
  public reason: SqlField;
  public raisedDate: SqlField;
  public heldAtRaise: SqlField;
  public status: SqlField;
  public resolution: SqlField;
  public vendorAmount: SqlField;
  public customerAmount: SqlField;
  public resolutionNote: SqlField;
  public resolvedDate: SqlField;
  public resolvedBy: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public raisedByCustomer: SqlNavHybrid;
  public resolvedByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingDispute', 'guid', '', 'id', 'bookingDispute_guid');
    this.bookingId = new SqlField('bookingDispute', 'bookingId', 'booking', 'id', 'bookingDispute_booking');
    this.raisedByCustomerId = new SqlField('bookingDispute', 'raisedByCustomerId', '', 'id', 'bookingDispute_raisedByCustomer');
    this.reasonCode = new SqlField('bookingDispute', 'reasonCode', '', 'id', 'bookingDispute_reasonCode');
    this.reason = new SqlField('bookingDispute', 'reason', '', 'id', 'bookingDispute_reason');
    this.raisedDate = new SqlField('bookingDispute', 'raisedDate', '', 'id', 'bookingDispute_raisedDate');
    this.heldAtRaise = new SqlField('bookingDispute', 'heldAtRaise', '', 'id', 'bookingDispute_heldAtRaise');
    this.status = new SqlField('bookingDispute', 'status', '', 'id', 'bookingDispute_status');
    this.resolution = new SqlField('bookingDispute', 'resolution', '', 'id', 'bookingDispute_resolution');
    this.vendorAmount = new SqlField('bookingDispute', 'vendorAmount', '', 'id', 'bookingDispute_vendorAmount');
    this.customerAmount = new SqlField('bookingDispute', 'customerAmount', '', 'id', 'bookingDispute_customerAmount');
    this.resolutionNote = new SqlField('bookingDispute', 'resolutionNote', '', 'id', 'bookingDispute_resolutionNote');
    this.resolvedDate = new SqlField('bookingDispute', 'resolvedDate', '', 'id', 'bookingDispute_resolvedDate');
    this.resolvedBy = new SqlField('bookingDispute', 'resolvedBy', '', 'id', 'bookingDispute_resolvedBy');
    this.booking = createNavHybrid('bookingDispute', 'bookingDispute_booking', 'Booking');
    this.createdByUser = createNavHybrid('bookingDispute', 'bookingDispute_createdByUser', 'User');
    this.raisedByCustomer = createNavHybrid('bookingDispute', 'bookingDispute_raisedByCustomer', 'Customer');
    this.resolvedByUser = createNavHybrid('bookingDispute', 'bookingDispute_resolvedByUser', 'User');
    this.updatedByUser = createNavHybrid('bookingDispute', 'bookingDispute_updatedByUser', 'User');
    this.id = new SqlField('bookingDispute', 'id', '', 'id', 'bookingDispute_id');
    this.isDeleted = new SqlField('bookingDispute', 'isDeleted', '', 'id', 'bookingDispute_isDeleted');
    this.createdBy = new SqlField('bookingDispute', 'createdBy', '', 'id', 'bookingDispute_createdBy');
    this.createdDate = new SqlField('bookingDispute', 'createdDate', '', 'id', 'bookingDispute_createdDate');
    this.updatedBy = new SqlField('bookingDispute', 'updatedBy', '', 'id', 'bookingDispute_updatedBy');
    this.updatedDate = new SqlField('bookingDispute', 'updatedDate', '', 'id', 'bookingDispute_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingDisputeSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingDisputeSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingDisputeSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingDisputeSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingDisputeSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingDisputeSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingDisputeSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingDisputeSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingDisputeSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingDisputeSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
